export const TRANSLATIONS_VOTING_COOKIE_NAME = 'VCR.TranslationVoting';

export const TRANSLATIONS_VOTING_EXPIRATION_TIME: number = 94670778000;

export const TRANSLATIONS_VOTING_DELIMITER = '|';
